export default __webpack_public_path__ + "static/media/sg-icon.d11e32e2.svg";